import { render } from "./WalletRequest.vue?vue&type=template&id=56b62488"
import script from "./WalletRequest.vue?vue&type=script&lang=js"
export * from "./WalletRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__